import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ManualAtt from './components/ManualAtt';
import AppliedLeave from './components/AppliedLeave';
import classes from './NotificationIcon.module.scss';
import { notificationAction } from '../../../../Redux/action/interactions';

const NotificationDrawer = ({dataChange}) => {
    const [tabs, setTabs] = useState(1);
    const dispatch = useDispatch()


    const nexTab = (id) => {
        setTabs(id)
    }
    const closeDrawer = () => {
        dispatch(notificationAction(false))
    }

    const state = useSelector(state => state.interactions.notification)
    return (
        <>
            <div className={state ? classes.NotificationDrawerActive : classes.NotificationDrawerInActive}>

                <div className={classes.ClosingButton} onClick={closeDrawer}><h2>Approval Notifications</h2><span>X</span></div>
                <div className={classes.Buttons}>
                    <span className={tabs === 1 ? classes.Active : classes.InActive} onClick={() => { nexTab(1) }}>Mannual Att</span>
                    <span className={tabs === 2 ? classes.Active : classes.InActive} onClick={() => { nexTab(2) }}>Leaves</span>
                </div>
                <div className={classes.NotificationTab}>
                    {tabs === 1 ? <ManualAtt handleChange={dataChange}/> : tabs === 2 ? <AppliedLeave handleChange={dataChange}/> : ""}
                </div>
            </div>

        </>
    )
}

export default NotificationDrawer
